import api from "./apiWithAccessToken";

/* GET USER ALLOWED TABLES (Dropdown)*/
export const getAllowedTables = (db_id) => api.get(`/export/allowed-tables?db_id=${db_id}`);

/*GET TABLE METADATA (Columns + Filter Info)
   Accepts multiple tables: tables=table1,table2
*/
export const getExportTableColumns = (tables, db_id) => api.get(`/export/columns?tables=${tables}&db_id=${db_id}`);

/* EXPORT CSV (Streaming) */
export const exportTableCSV = (payload) =>
  api.post("/export/csv", payload, {
    responseType: "blob",
  });